import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection
} from '@angular/core';
import {provideRouter} from '@angular/router';
import {routes} from './app.routes';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {HttpClient, provideHttpClient, withInterceptors,} from "@angular/common/http";
import {TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {ConfigurationService} from "./shared/services/configuration.service";
import {DatePipe} from "@angular/common";
import {MatDateFormats} from "@angular/material/core";
import {provideMomentDateAdapter} from "@angular/material-moment-adapter";
import {provideKeycloakAngular} from "./keycloak/keycloak.config";
import {includeBearerTokenInterceptor} from "keycloak-angular";
import {firstValueFrom} from "rxjs";
import {errorInterceptor} from "./shared/interceptors/error.interceptor";

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './i18n/', '.json');
}

export const provideTranslation = () => ({
  defaultLanguage: 'en',
  loader: {
    provide: TranslateLoader,
    useFactory: HttpLoaderFactory,
    deps: [HttpClient],
  },
});

export const DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'DD.MM.YYYY',
  },
  display: {
    dateInput: 'DD.MM.YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({eventCoalescing: true}),
    provideAppInitializer(() => {
      const http = inject(HttpClient);
      return firstValueFrom(inject(ConfigurationService).loadConfig(http));
    }),
    provideHttpClient(withInterceptors([includeBearerTokenInterceptor, errorInterceptor])),
    provideKeycloakAngular({
      url: 'https://login.dataunit.ch/auth',
      realm: localStorage.getItem('realm') ?? '',
      clientId: 'licenseportal',
    }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideMomentDateAdapter(DATE_FORMATS),
    DatePipe,
    importProvidersFrom(TranslateModule.forRoot(provideTranslation())),
  ]
};
